import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import First from "./assets/images/first.gif";
import Second from "./assets/images/second.gif";
import Third from "./assets/images/third.gif";
import Portfolio1 from "./assets/images/portfolio-1.webp";
import PortfolioTwo from "./assets/images/portfolio-2.webp";
import PortfolioThree from "./assets/images/portfolio-3.webp";
import PortfolioFour from "./assets/images/portfolio-4.webp";
import { GoArrowUpRight } from "react-icons/go";
import { FaLinkedinIn } from "react-icons/fa6";
import CopyBox from "./CopyBox";

const HomeBody = () => {

  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <>
      <main>
        <section className="about-me pt-5">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="text-center content-box w-80 mx-auto">
                  <h1 className="fs-24 mb-3 fw-normal fm-soli">
                    Hello, I’m Hovarthini
                  </h1>
                  <p className="fw-medium fs-48px lh-base">
                    Solving problems with thoughtful design because when users
                    win, brands do too.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container pb-5">
            <div className="row justify-content-center images-box-3 w-80 mx-auto my-5">
              <div className="col-md-4 my-3">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="fm-soli fs-24 mb-0">Users</p>
                  <div className="img-box">
                    <img
                      src={First}
                      alt="User Icon"
                      className="first img-cover"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4 my-5">
                <div className="d-flex gap-3 align-items-center flex-column-reverse second-section">
                  <p className="fm-soli fs-24 mb-0">Accessiblity</p>
                  <div className="img-box">
                    <img
                      src={Second}
                      alt="User Icon"
                      className="second img-cover"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4 my-3">
                <div className="d-flex justify-content-between align-items-center flex-row-reverse">
                  <p className="fm-soli fs-24 mb-0">Business</p>
                  <div className="img-box">
                    <img
                      src={Third}
                      alt="User Icon"
                      className="third img-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-12 mt-5">
                <p className=" fs-24 lh-base text-center w-75 mx-auto">
                  As an aspiring UX designer, I focus on continuous learning,
                  refining experiences, and making accessibility a must-have,
                  not a luxury. Because a product that works for everyone isn’t
                  just good design, it’s the foundation of lasting impact.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="mb-5 portfolio-cards" id="work">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-5 my-4">
                <NavLink
                  to="/ecom-project"
                  className="text-decoration-none text-dark"
                >
                  <div className="portfolio-list-1">
                    <div className="py-4 text-end px-2">
                      <div className="d-flex justify-content-end gap-2">
                        <span className="mb-0 lk-btn">E-com</span>
                        <span className="mb-0 lk-btn">D2C</span>
                      </div>
                    </div>
                    <p className="px-3 fm-soli mb-3 fs-24">Roar South</p>
                    <p className="fs-24 px-3 fs-24 text-center fw-medium">
                      Explore your products while highlighting clarity,
                      personalization, and ease of use.
                    </p>
                    <div className="port-list-img">
                      <img
                        className="img-cover"
                        src={Portfolio1}
                        alt="Roar South"
                      />
                    </div>
                  </div>
                </NavLink>
              </div>
              <div className="col-md-5 my-4">
                <NavLink
                  to={"/divido-project"}
                  className="portfolio-list-1 portfolio-list-2"
                >
                  <div className="py-4 text-end px-2">
                    <div className="d-flex justify-content-end gap-2">
                      <span className="mb-0 lk-btn">Fin Tech</span>
                      <span className="mb-0 lk-btn">B2B</span>
                    </div>
                  </div>
                  <p className="px-3 fm-soli mb-3 fs-24">Divido</p>
                  <p className="fs-24 px-3 fs-24 text-center fw-medium">
                    Stay ahead with everything in one clear, accessible
                    dashboard.
                  </p>
                  <div className="port-list-img img-centered mx-auto">
                    <img
                      className="img-cover"
                      src={PortfolioTwo}
                      alt="Divido"
                    />
                  </div>
                </NavLink>
              </div>
              <div className="col-md-5 my-4">
                <NavLink
                  to={"/pixel-project"}
                  className="portfolio-list-1 portfolio-list-3"
                >
                  <div className="py-4 text-end px-2">
                    <div className="d-flex justify-content-end gap-2">
                      <span className="mb-0 lk-btn">Design</span>
                      <span className="mb-0 lk-btn">B2C</span>
                    </div>
                  </div>
                  <p className="px-3 fm-soli mb-3 fs-24">Pixel</p>
                  <p className="fs-24 px-3 fs-24 text-center fw-medium mb-4">
                    Create, customize, and share effortlessly, design for every
                    platform with ease and accessibility.
                  </p>
                  <br className="mb-3" />
                  <div className="port-list-img mx-auto img-three">
                    <img
                      className="img-cover"
                      src={PortfolioThree}
                      alt="pixel"
                    />
                  </div>
                </NavLink>
              </div>
              <div className="col-md-5 my-4">
                <NavLink
                  to={"/igniteai-project"}
                  className="portfolio-list-1 portfolio-list-4"
                >
                  <div className="py-4 text-end px-2">
                    <div className="d-flex justify-content-end gap-2">
                      <span className="mb-0 lk-btn">Bi/ Data</span>
                      <span className="mb-0 lk-btn">B2B</span>
                    </div>
                  </div>
                  <p className="px-3 fm-soli mb-3 fs-24">Ignite AI</p>
                  <p className="fs-24 px-3 fs-24 text-center fw-medium">
                    Effortless insights at your fingertips ,an AI powered
                    dashboard that transforms complex data into clear,
                    actionable insights.
                  </p>
                  <div className="port-list-img img-four">
                    <img
                      className="img-cover"
                      src={PortfolioFour}
                      alt="Ignite AI"
                    />
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </section>
        <section className="footer mb-5">
          <div className="container">
            <div className="bg-setting p-3 pb-5">
              <div className="row align-items-center">
                <div className="col-md-6 my-2">
                  <div className="foot-box p-4 mb-4 position-relative">
                    <p className="mb-0 fs-40px fw-normal fm-soli w-75 lh-bash text-dark">
                      Things Potential Employers ask
                      <br /> me
                    </p>
                    <div className="position-absolute arrow-mark d-none d-md-block">
                      <GoArrowUpRight />
                      <div className="hover-content-div p-3">
                        <div className="p-3 bg-white mb-3">
                          <p className="fs-24  fm-soli">
                            What positions are you looking for?
                          </p>
                          <p className="fs-24">
                            I am looking for Product Designer and UX Designer
                            roles.
                          </p>
                        </div>
                        <div className="p-3 bg-white mb-3">
                          <p className="fs-24  fm-soli">
                            Are you willing to relocate?
                          </p>
                          <p className="fs-24">
                            I can relocate to Bangalore for the right
                            opportunity.
                          </p>
                        </div>
                        <div className="p-3 bg-white mb-3">
                          <p className="fs-24  fm-soli">
                            What skills do you have as a UI/UX designer?
                          </p>
                          <p className="fs-24">
                            I'm good with design tools like Figma and Adobe XD.
                            My skills include user research wireframing,
                            prototyping and accessibility. I also have a strong
                            understanding of visual design, usability testing,
                            and user psychology.
                          </p>
                        </div>
                        <div className="p-3 bg-white mb-3">
                          <p className="fs-24  fm-soli">
                            Have you worked on any real-world projects?
                          </p>
                          <p className="fs-24">
                            I haven’t worked professionally yet, but I
                            continuously work on mock projects to enhance my
                            skills
                          </p>
                        </div>
                        <div className="p-3 bg-white mb-0">
                          <p className="fs-24  fm-soli">
                            What makes your UI/UX approach unique?
                          </p>
                          <p className="fs-24">
                            I focus on accessibility, minimalism, and user
                            engagement while ensuring that the design aligns
                            with business goals.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="position-absolute arrow-mark d-block d-md-none">
                      <GoArrowUpRight
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasRight"
                        aria-controls="offcanvasRight"
                      />
                      <div
                        class="offcanvas mob-offcanvas offcanvas-bottom"
                        tabindex="-1"
                        id="offcanvasRight"
                        aria-labelledby="offcanvasRightLabel"
                      >
                        <div class="offcanvas-header">

                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="offcanvas-body">
                          <div className="p-3">
                            <div className="p-3 bg-white mb-3">
                              <p className="fs-24  fm-soli">
                                What positions are you looking for?
                              </p>
                              <p className="fs-24">
                                I am looking for Product Designer and UX Designer
                                roles.
                              </p>
                            </div>
                            <div className="p-3 bg-white mb-3">
                              <p className="fs-24  fm-soli">
                                Are you willing to relocate?
                              </p>
                              <p className="fs-24">
                                I can relocate to Bangalore for the right
                                opportunity.
                              </p>
                            </div>
                            <div className="p-3 bg-white mb-3">
                              <p className="fs-24  fm-soli">
                                What skills do you have as a UI/UX designer?
                              </p>
                              <p className="fs-24">
                                I'm good with design tools like Figma and Adobe XD.
                                My skills include user research wireframing,
                                prototyping and accessibility. I also have a strong
                                understanding of visual design, usability testing,
                                and user psychology.
                              </p>
                            </div>
                            <div className="p-3 bg-white mb-3">
                              <p className="fs-24  fm-soli">
                                Have you worked on any real-world projects?
                              </p>
                              <p className="fs-24">
                                I haven’t worked professionally yet, but I
                                continuously work on mock projects to enhance my
                                skills
                              </p>
                            </div>
                            <div className="p-3 bg-white mb-0">
                              <p className="fs-24  fm-soli">
                                What makes your UI/UX approach unique?
                              </p>
                              <p className="fs-24">
                                I focus on accessibility, minimalism, and user
                                engagement while ensuring that the design aligns
                                with business goals.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="my-2 email d-flex align-items-center">
                    <a
                      className="fs-36px fw-semibold"
                      href="mailto:hovarthini@gmail.com"
                    >
                      hovarthini@gmail.com
                    </a>
                    <span>
                      <CopyBox />
                    </span>
                  </p>
                </div>
                <div className="col-md-6 my-2">
                  <div className="text-box-foot text-center mt-4 mb-mt-0">
                    <p className="fs-40px fw-medium">Let’s Connect!</p>
                    <p className="fs-36px mb-4">
                      I am open for Full-Time <br />
                      roles.
                    </p>
                    <a href="https://linkedin.com/in/hovarthini/" className="d-inline-block" target="_blank">
                      <span className="copy-box mt-o mt-md-5 d-inline-block">
                        <FaLinkedinIn />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default HomeBody;
